import { TefComs4p } from '@mfe/components/TefComs4p';
import { App } from '@mfec/types/model';
import { html } from 'lit';

//
// renders a single app consent block
//
// {app name}
// {app consent status}
//
export const singleAppConsentEdit = function render(this: TefComs4p, app: App) : ReturnType<typeof html> {
  return html`
    <div class="form-row row" data-consent-id="${app.consentId}">
      <div class="form-group-checkbox" @click=${(e : PointerEvent) => { this.toggleAppConsent(e, app); }}>
        <input id="app-${app.id}" type="checkbox" ?checked="${app.granted}"></input>
        <label style="font-size: x-large" for="app-${app.id}">${app.name}</label>
      </div>
    </div>
  `;
};
